import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { Constants } from '@arrived/common';
import { Position } from '@arrived/models';

import { MAX_STALE_TIME } from '../queries.utils';
import { openPositionsQueryKey } from './positions.keys';

export const useOpenPositionsQuery = (options?: UseQueryOptions<Position[]>): UseQueryResult<Position[]> =>
  useQuery(openPositionsQueryKey, () => fetch(`${Constants.breezyHomepage}/json`).then((response) => response.json()), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
